import React from 'react';
import { ErrorMessage } from 'formik';
import { Typography, Select } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import { colors } from '../constants';
import {
  StepTitle, FormSection, FormItem, SectionTitle, ErrorText,
  InfoBox, LargeSelect, LargeDatePicker
} from '../styledComponents';

const { Paragraph } = Typography;
const { Option } = Select;

const StepTestSelection = ({ values, errors, touched, setFieldValue }) => (
  <>
    <StepTitle level={4}>Lipoprotein(a) Test Request</StepTitle>
    <InfoBox>
      <div className="icon"><InfoCircleOutlined /></div>
      <div className="content">
        <Paragraph style={{ margin: 0, color: colors.text }}>
          Lipoprotein(a), or Lp(a), is an independent risk factor for cardiovascular disease. This test helps identify
          elevated levels which may not be detected in standard cholesterol tests.
        </Paragraph>
      </div>
    </InfoBox>
    
    <FormSection>
      <FormItem>
        <SectionTitle>Select Lab Location</SectionTitle>
        <Paragraph style={{ fontSize: '15px', color: colors.text, marginTop: '6px', marginBottom: '12px', lineHeight: '1.4', fontWeight: '400' }}>
          Choose where you would like to have your blood drawn:
        </Paragraph>
        <LargeSelect
          style={{ 
            width: '100%',
            borderColor: touched.labChoice && errors.labChoice ? colors.error : null 
          }}
          placeholder="Select Lab Location"
          value={values.labChoice}
          onChange={(value) => setFieldValue('labChoice', value)}
        >
          <Option value="CPL">Clinical Pathology Laboratories (CPL)</Option>
          <Option value="Quest">Quest Diagnostics</Option>
        </LargeSelect>
        <ErrorMessage name="labChoice" component={ErrorText} />
      </FormItem>
      
      <FormItem>
        <SectionTitle>Preferred Testing Date</SectionTitle>
        <LargeDatePicker
          style={{ 
            width: '100%',
            borderColor: touched.requestDate && errors.requestDate ? colors.error : null 
          }}
          format="MM/DD/YYYY"
          placeholder="Select your preferred date"
          value={values.requestDate ? moment(values.requestDate) : moment()}
          onChange={(date, dateString) => setFieldValue('requestDate', dateString)}
          disabledDate={(current) => {
            return current && current < moment().startOf('day');
          }}
        />
        <Paragraph style={{ fontSize: '14px', color: colors.text, marginTop: '10px', lineHeight: '1.5', fontWeight: '400' }}>
          Note: The lab may contact you to confirm availability and schedule a specific time.
        </Paragraph>
        <ErrorMessage name="requestDate" component={ErrorText} />
      </FormItem>
    </FormSection>
  </>
);

export default StepTestSelection;
